import { FC, useMemo } from 'react';

interface ITimerProps {
  readonly time: number;
}
export const Timer: FC<ITimerProps> = ({ time }) => {
  const value = useMemo(() => {
    const timer = new Date(time * 1000).toISOString().slice(14, 19);
    return timer;
  }, [time]);

  return <small>{value}</small>;
};
